module.exports = __webpack_public_path__ + "img/rate6.4b8a66e0.png";